import { UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BoneTypeEnum } from '../../core';
import { BaseComponent, BoneTypeLabelPipe } from '../../shared';


/**
* Component of first vertical sidebar to handle the bone type selection.
*/
@Component({
	selector: 'bone-type-selection',
	templateUrl: './bone-type-selection.component.html',
	imports: [
		FormsModule,
		UpperCasePipe,
		BoneTypeLabelPipe
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class BoneTypeSelectionComponent extends BaseComponent implements OnInit {

	boneType?: BoneTypeEnum;
	boneTypeEnum = BoneTypeEnum;


	ngOnInit(): void {
		this.boneType = this.boneTypeLT;
	}

	/**
	 * Ends bone type selection workflow without confirm.
	 */
	back(): void {
		this.canvasSrv.dispatch('cancelBoneTypeSelection');
	}

	/**
	 * Confirm bone type selection workflow and ends workflow.
	 */
	confirm(): void {
		this.canvasSrv.dispatch('confirmBoneTypeSelection', this.boneType);
		this.canvasSrv.dispatch('mechanical-axes-btn');
	}

}
